<template>
  <ion-header :collapse="collapse" class="ion-padding-horizontal my-header">
    <ion-toolbar>
      <ion-title :class="{ 'ion-no-padding': !collapse }" :size="size">
        <div class="header-title">
          <img v-if="icon" :src="icon" class="header-title-icon" />
          {{ title }}
          <slot />
        </div>
      </ion-title>
      <ion-button
        v-if="showClose"
        slot="end"
        class="button ion-no-margin ion-no-padding"
        fill="clear"
        color="dark"
        @click="$emit('close')"
      >
        <ion-icon :icon="close"></ion-icon>
      </ion-button>
    </ion-toolbar>
  </ion-header>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { close } from 'ionicons/icons'
import { IonHeader, IonButton, IonToolbar, IonTitle, IonIcon } from '@ionic/vue'

export default defineComponent({
  components: {
    IonHeader,
    IonButton,
    IonToolbar,
    IonTitle,
    IonIcon,
  },
  props: {
    showClose: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    size: {
      type: String as PropType<'small' | 'large' | undefined>,
      default: undefined,
    },
    collapse: {
      type: String as PropType<'condense' | undefined>,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
  },
  emits: ['close'],
  setup() {
    return {
      close,
    }
  },
})
</script>

<style scoped lang="scss">
.my-header {
  background: #fff;
}
.header-title {
  display: flex;
  align-items: center;
  &-icon {
    margin-right: 6px;
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
}
</style>
